import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_MASSOPS = `${URL_APP_ADMIN}/massops`
const URL_MASSOPS_EVENTS_LIST_LANDING = `${URL_MASSOPS}/interventions`
const URL_MASSOPS_INTERVENTION = `${URL_MASSOPS}/intervention/:interventionId`
const URL_MASSOPS_CREATE_INTERVENTION = `${URL_MASSOPS}/create-intervention`
const URL_MASSOPS_APPROVE_INTERVENTION = `${URL_MASSOPS}/approve-intervention/:interventionId`
const URL_MASSOPS_UPLOAD_INTERVENTION_DATA = `${URL_MASSOPS}/upload-intervention-data/:interventionId`
const URL_MASSOPS_INTERVENTION_SETTINGS = `${URL_MASSOPS}/intervention/:interventionId/settings`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'massops'>
  | DashRouteType<'massops-interventions'>
  | DashRouteType<'massops-intervention', { interventionId?: string }>
  | DashRouteType<'massops-create-intervention'>
  | DashRouteType<'massops-approve-intervention', { interventionId?: string }>
  | DashRouteType<'massops-upload-intervention-data'>
  | DashRouteType<'massops-intervention-settings', { interventionId?: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  massops: URL_MASSOPS,
  'massops-interventions': URL_MASSOPS_EVENTS_LIST_LANDING,
  'massops-intervention': URL_MASSOPS_INTERVENTION,
  'massops-create-intervention': URL_MASSOPS_CREATE_INTERVENTION,
  'massops-approve-intervention': URL_MASSOPS_APPROVE_INTERVENTION,
  'massops-upload-intervention-data': URL_MASSOPS_UPLOAD_INTERVENTION_DATA,
  'massops-intervention-settings': URL_MASSOPS_INTERVENTION_SETTINGS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
